import("../src/javascripts/attachments-redesign");
import("../src/javascripts/navigation");
import("../src/javascripts/slider_splide");
import copyToClipboard from '../src/javascripts/copy-to-clipboard';

document.addEventListener('click', function (e) {
  const trigger = e.target.closest('.js-copy-to-clipboard');
  if (!trigger) return;

  e.preventDefault();
  const text = trigger.dataset.copyText;
  if (!text) return;

  copyToClipboard(text);

  const original = trigger.innerHTML;
  trigger.innerHTML = 'Copied!';
  setTimeout(function () { trigger.innerHTML = original; }, 1500);
});
